<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" icon="md-cloud-upload" style="margin-left: 20px;"
				@click="clickImport">导入Excel</Button>
			<Button type="primary" style="margin-left: 20px;" @click="downTemplate">下载模版</Button>
		</div>

		<Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1"
			@on-selection-change="onSelectionChange" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="deparams">
				<div style="display: flex;justify-content: space-around;">
					<Button type="primary" @click="clickUnbindBase(row)" style="padding: 5px 5px 6px;">解绑</Button>
				</div>
			</template>
		</Table>
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Upload ref="upload" name="file" :action="importUrl" :on-success="onUploadSuccess" :format="['xlsx','xls']"
			:show-upload-list="false" style="display: none;">
			<Button />
		</Upload>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<Icon type="md-create" />
				<span>搜索</span>
			</p>
			<div style="text-align:center">
				<CheckboxGroup v-model="selectedCondition" class="check_grop">
					<div>
						<Checkbox label="meterId">
							<span>基表编号</span>
						</Checkbox>
						<Input v-model="meterId" placeholder="请输入基表编号" style="width: 200px" />
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "meter_alarm_bind_manage",
		data() {
			let that = this;
			return {
				columns1: [{
						type: "selection",
						width: 50,
						align: "center"
					},
					{
						title: "基表编号",
						width: 200,
						key: "num",
						align: "center"
					},
					{
						title: "报警器编号",
						width: 200,
						key: "alarmNum",
						align: "center"
					},
					{
						title: "操作",
						width: 200,
						slot: "deparams",
						align: "center"
					}
				],
				meterId: '',
				importUrl: '/api/meter/admin/alarm_bind/imports',
				templateUrl: 'http://www.cnzhuocheng.cn/' + encodeURIComponent('报警器绑定导入模板.xls'),
				selection: [],
				currentRow: null,
				data1: [],
				loading: true,
				modal8: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showBindBase: false,
				bindBaseNum: '',
			};
		},
		created() {
			this.getDataList();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickImport() {
				this.$refs.upload.$el.children[0].children[0].dispatchEvent(new MouseEvent('click'));
			},
			onUploadSuccess(response, file, fileList) {
				if (!response.success) {
					this.$Notice.error({
						title: "异常",
						desc: response.msg
					});
					this.getDataList();
					return;
				}

				this.$Notice.success({
					title: "提示",
					desc: "导入" + response.data.count + "条，" +
						'成功' + response.data.successCount +
						'条，失败' + response.data.failureCount +
						'条，忽略' + response.data.skipCount + '条'
				});
				this.getDataList();
			},
			downTemplate() {
				window.location.href = this.templateUrl + "?" + new Date();
			},
			onSelectionChange(selection) {
				this.selection = selection;
			},
			clickUnbindBase(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认解绑？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/alarm_bind/unbind",
							type: "post",
							data: {
								num: row.num
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.$Notice.success({
									title: "提示",
									desc: "解绑成功"
								});
								that.getDataList();
							},
							error: function(textStatus) {
								that.$Notice.error({
									title: "提示",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			getDataList() {
				var that = this;
				if (localStorage.getItem("isAdmin") != "true") {
					that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
				}
				that.loading = true;
				$.ajax({
					url: "/api/meter/admin/alarm_bind/getPage?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.selection = [];
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
